import { ArrowLeftOutlined } from '@ant-design/icons';
import { EnumCambiamentoStatoRequestTransizione } from '@framework/api-client';
import { useCurrentUser } from '@framework/auth';
import {
  IModuleStateMachineRecord,
  ModuleStateMachine,
  SubmissionModuleState,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { AsyncButton } from '@framework/ui';
import React, { useMemo } from 'react';
import { ActionButtonContainer } from './ActionButtonContainer';
import { ActionMessage } from './ActionMessage';
import { useSubmissionModuleStateChanger } from './useSubmissionModuleStateChanger';

export interface ISignToCompilationButtonProps {
  data: IModuleStateMachineRecord;
}

export function SignToCompilationButton(props: ISignToCompilationButtonProps) {
  const { data } = props;

  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const canSignToCompilation = useMemo(() => {
    return ModuleStateMachine.canTransition(data, {
      from: SubmissionModuleState.Sign,
      to: SubmissionModuleState.Compilation,
      user: currentUser,
    });
  }, [currentUser, data]);

  const { handleClick } = useSubmissionModuleStateChanger({
    data,
    successMessage: t(
      'submission-action-button.modulo-nuovamente-compilabile',
      'Modulo nuovamente compilabile',
    ),
  });

  if (!canSignToCompilation.allowed) return null;

  return (
    <ActionButtonContainer
      message={
        <ActionMessage
          message={t(
            'submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare',
            'Il modulo è stato compilato, puoi ritornare in compilazione se sono necessarie modifiche.',
          )}
          type="info"
        />
      }
      button={
        <AsyncButton
          block
          size="large"
          onClick={() =>
            handleClick(
              EnumCambiamentoStatoRequestTransizione.RIPORTA_IN_COMPILAZIONE,
            )
          }
        >
          <ArrowLeftOutlined aria-hidden="true" />{' '}
          {t(
            'submission-action-button.ritorna-in-compilazione',
            'Ritorna in compilazione',
          )}
        </AsyncButton>
      }
    />
  );
}
